/** String action type for legacy setStore / dispatch(fn) updates (RTK requires string types). */
export const APPLY_UPDATER = "@@app/APPLY_UPDATER";
